import type {
  LoyaltyDiscountsBookingPanel,
  LoyaltyDiscountsStateBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/loyaltyDiscountsBookingPanel';

export const get = (
  state: LoyaltyDiscountsStateBookingPanel | undefined,
  id: string,
): LoyaltyDiscountsBookingPanel | undefined => state?.itineraries.byId[id];
